import(/* webpackMode: "eager" */ "/home/xuba0728/nodevenv/affectio-site/19/lib/node_modules/next/dist/client/components/app-router.js");
;
import(/* webpackMode: "eager" */ "/home/xuba0728/nodevenv/affectio-site/19/lib/node_modules/next/dist/client/components/client-page.js");
;
import(/* webpackMode: "eager" */ "/home/xuba0728/nodevenv/affectio-site/19/lib/node_modules/next/dist/client/components/error-boundary.js");
;
import(/* webpackMode: "eager" */ "/home/xuba0728/nodevenv/affectio-site/19/lib/node_modules/next/dist/client/components/layout-router.js");
;
import(/* webpackMode: "eager" */ "/home/xuba0728/nodevenv/affectio-site/19/lib/node_modules/next/dist/client/components/not-found-boundary.js");
;
import(/* webpackMode: "eager" */ "/home/xuba0728/nodevenv/affectio-site/19/lib/node_modules/next/dist/client/components/render-from-template-context.js");
